import { isNumeric } from '80.quickConnect.Core/helpers/common';
import { CounterDesc } from '90.quickConnect.Models/models';

const mapCounterDesc = (field: CounterDesc): CounterDesc => {
  const counterDefault = isNumeric(field.defaultValue) ? field.defaultValue : undefined;
  return {
    min: field.min ?? 0,
    max: field.max ?? 100,
    isVertical: field.isVertical,
    value: field.value ?? counterDefault,
    defaultValue: counterDefault,
  } as CounterDesc;
};

export default mapCounterDesc;
